import React from "react";
import { useNavigate } from "react-router-dom";
import { FiArrowRight } from "react-icons/fi";
import Background from "../../assets/headerGalvanisPhone.jpg";
import FotoHeader from "../../assets/coilAbuProducts.jpeg";

const SalesPerson = () => {
  const navigate = useNavigate();

  return (
    <>
      {/* APLIKASI PC */}
      <section className="hidden sm:block">
        <h1 className="text-4xl container-screen text-primaryPandawa font-helvetica text-left">
          SALES PERSON
        </h1>
        <section className="container-screen grid grid-cols-5 py-10">
          <div className="col-span-5">
            <div>
              <div className="text-left">
                <div>
                  <div className="flex items-center gap-2">
                    <h2 className="font-helvetica font-bold ">
                      Job Description
                    </h2>
                  </div>
                </div>
              </div>

              <div className="mt-4">
                <ul className="list-disc list-outside pl-5 space-y-2 text-gray-700 text-left">
                  <li className="font-montserrat">
                    Mencari dan membina hubungan dengan pelanggan baru
                    (prospecting).
                  </li>
                  <li className="font-montserrat">
                    Menjaga dan meningkatkan hubungan baik dengan pelanggan
                    existing.
                  </li>
                  <li className="font-montserrat">
                    Menawarkan dan menjual produk sesuai dengan kebutuhan klien.
                  </li>
                  <li className="font-montserrat">
                    Menyiapkan dan melakukan presentasi penjualan kepada calon
                    pelanggan.
                  </li>
                  <li className="font-montserrat">
                    Menyusun penawaran harga dan follow-up hingga deal terjadi.
                  </li>
                  <li className="font-montserrat">
                    Memantau proses pengiriman dan memastikan kepuasan
                    pelanggan.
                  </li>
                  <li className="font-montserrat">
                    Melakukan kunjungan rutin ke pelanggan atau calon pelanggan.
                  </li>
                  <li className="font-montserrat">
                    Mencapai atau melebihi target penjualan yang telah
                    ditetapkan.
                  </li>
                  <li className="font-montserrat">
                    Membuat laporan penjualan harian/mingguan/bulanan kepada
                    atasan.
                  </li>
                  <li className="font-montserrat">
                    Bekerja sama dengan tim internal seperti logistik, finance,
                    dan admin sales.
                  </li>
                </ul>
              </div>

              <div className="text-left mt-10">
                <div className="flex items-center gap-2">
                  <h2 className="font-helvetica font-bold ">Kualifikasi</h2>
                </div>
              </div>

              <div className="mt-4">
                <ul className="list-disc list-outside pl-5 space-y-2 text-gray-700 text-left">
                  <li className="font-montserrat">
                    Minimal lulusan SMA/SMK/ D3/S1
                  </li>
                  <li className="font-montserrat">
                    Pengalaman minimal 1 tahun sebagai Sales, lebih disukai di
                    bidang industri terkait (contoh: baja, material bangunan,
                    manufaktur, dll).
                  </li>
                  <li className="font-montserrat">
                    Memiliki SIM A/C dan bersedia melakukan kunjungan lapangan.
                  </li>
                  <li className="font-montserrat">
                    Tidak memiliki pengalaman juga welcome
                  </li>
                </ul>
              </div>

              <div className="text-left mt-10">
                <div className="flex items-center gap-2">
                  <h2 className="font-helvetica font-bold ">
                    Keterampilan Lain
                  </h2>
                </div>
              </div>

              <div className="mt-4">
                <ul className="list-disc list-outside pl-5 space-y-2 text-gray-700 text-left">
                  <li className="font-montserrat">
                    Komunikasi dan negosiasi yang baik.
                  </li>
                  <li className="font-montserrat">
                    Target-oriented dan memiliki inisiatif tinggi.
                  </li>
                  <li className="font-montserrat">
                    Mampu bekerja secara individu maupun tim.
                  </li>
                  <li className="font-montserrat">
                    Menguasai Microsoft Office dan aplikasi CRM (jika ada).
                  </li>
                  <li className="font-montserrat">
                    Ramah, persuasif, jujur, dan profesional dalam berinteraksi.
                  </li>
                  <li className="font-montserrat">
                    Siap bekerja dengan tekanan dan deadline.
                  </li>
                  <li className="font-montserrat">
                    Disiplin, tanggap, dan bertanggung jawab.
                  </li>
                </ul>
              </div>

              <div className="lg:mt-10 flex justify-start">
                <button
                  onClick={() =>
                    window.open(
                      "https://mail.google.com/mail/?view=cm&fs=1&to=hr@pandawajayasteel.co.id&su=Lamaran%20Kerja%20-%20Sales%20Person&body=Halo%2C%20saya%20ingin%20melamar%20untuk%20posisi%20Sales%20Person",
                      "_blank"
                    )
                  }
                  className="bg-primaryPandawa hover:bg-primaryPandawa/90 transition duration-300 px-6 py-3 rounded-lg shadow-md text-white font-semibold"
                >
                  Lamar Sekarang
                </button>
              </div>
              <p className="text-left text-xs mt-2 text-gray-500">
                *Jika terdapat kendala silahkan lampirkan CV secara manual ke
                hr@pandawajayasteel.co.id
              </p>
            </div>
          </div>
          {/* <div className="col-span-2 rounded-lg overflow-hidden ml-auto h-full w-3/4">
            <img src={Background} className="h-full" alt="Background" />
          </div> */}
        </section>
      </section>

      {/* MOBILE VERSION */}
      {/* MOBILE VERSION */}
      <section className="sm:hidden bg-white py-8">
        <div className="container-screen text-left">
          <h1 className="font-helvetica text-primaryPandawa text-left text-2xl mb-6 font-bold">
            SALES PERSON
          </h1>

          {/* Job Description */}
          <div className="mb-8">
            <h2 className="font-helvetica font-bold text-lg mb-3 text-primaryPandawa">
              Job Description
            </h2>
            <ul className="list-disc list-outside pl-5 space-y-2 text-gray-800 text-sm">
              <li>
                Mencari dan membina hubungan dengan pelanggan baru
                (prospecting).
              </li>
              <li>
                Menjaga dan meningkatkan hubungan baik dengan pelanggan
                existing.
              </li>
              <li>
                Menawarkan dan menjual produk sesuai dengan kebutuhan klien.
              </li>
              <li>
                Menyiapkan dan melakukan presentasi penjualan kepada calon
                pelanggan.
              </li>
              <li>
                Menyusun penawaran harga dan follow-up hingga deal terjadi.
              </li>
              <li>
                Memantau proses pengiriman dan memastikan kepuasan pelanggan.
              </li>
              <li>
                Melakukan kunjungan rutin ke pelanggan atau calon pelanggan.
              </li>
              <li>
                Mencapai atau melebihi target penjualan yang telah ditetapkan.
              </li>
              <li>
                Membuat laporan penjualan harian/mingguan/bulanan kepada atasan.
              </li>
              <li>
                Bekerja sama dengan tim internal seperti logistik, finance, dan
                admin sales.
              </li>
            </ul>
          </div>

          {/* Kualifikasi */}
          <div className="mb-8">
            <h2 className="font-helvetica font-bold text-lg mb-3 text-primaryPandawa">
              Kualifikasi
            </h2>
            <ul className="list-disc list-outside pl-5 space-y-2 text-gray-800 text-sm">
              <li>Minimal lulusan SMA/SMK/ D3/S1</li>
              <li>
                Pengalaman minimal 1 tahun sebagai Sales, lebih disukai di
                bidang industri terkait (contoh: baja, material bangunan,
                manufaktur, dll).
              </li>
              <li>
                Memiliki SIM A/C dan bersedia melakukan kunjungan lapangan.
              </li>
              <li>Tidak memiliki pengalaman juga welcome</li>
            </ul>
          </div>

          {/* Keterampilan Lain */}
          <div className="mb-8">
            <h2 className="font-helvetica font-bold text-lg mb-3 text-primaryPandawa">
              Keterampilan Lain
            </h2>
            <ul className="list-disc list-outside pl-5 space-y-2 text-gray-800 text-sm">
              <li>Komunikasi dan negosiasi yang baik.</li>
              <li>Target-oriented dan memiliki inisiatif tinggi.</li>
              <li>Mampu bekerja secara individu maupun tim.</li>
              <li>Menguasai Microsoft Office dan aplikasi CRM (jika ada).</li>
              <li>
                Ramah, persuasif, jujur, dan profesional dalam berinteraksi.
              </li>
              <li>Siap bekerja dengan tekanan dan deadline.</li>
              <li>Disiplin, tanggap, dan bertanggung jawab.</li>
            </ul>
          </div>

          {/* Tombol Lamar */}
          <div className="text-center mt-8 w-full">
            <button
              onClick={() =>
                (window.location.href =
                  "mailto:hr@pandawajayasteel.co.id?subject=Lamaran%20Kerja%20-%20Sales%20Person&body=Halo%2C%20saya%20ingin%20melamar%20untuk%20posisi%20Sales%20Person")
              }
              className="bg-primaryPandawa hover:bg-primaryPandawa/90 transition duration-300 px-6 py-3 rounded-lg shadow-md text-white font-semibold w-full"
            >
              Lamar Sekarang
            </button>
          </div>
          <p className="text-left text-xs mt-2 text-gray-500">
            *Jika terdapat kendala silakan lampirkan CV secara manual ke
            hr@pandawajayasteel.co.id
          </p>
        </div>
      </section>
    </>
  );
};

export default SalesPerson;
